import { render, staticRenderFns } from "./remove-dialog.pug?vue&type=template&id=04259454&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./remove-dialog.scss?vue&type=style&index=0&id=04259454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04259454",
  null
  
)

export default component.exports